import { AppTable } from 'shared/UI/UIKit/Table';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { BellScheduleCreate } from 'entities/bell-schedule';
import { useBellSchedulesTable } from '../model';

export const BellSchedulesTable = () => {
  const {
    state: { dataSource, columns },
    methods: { refreshTable },
  } = useBellSchedulesTable();

  return (
    <AppFlex direction="column">
      <BellScheduleCreate refreshTable={refreshTable} />
      <AppTable dataSource={dataSource} columns={columns} rowKey={(record) => record.id} />
    </AppFlex>
  );
};
